/* eslint-disable */
import React from "react";

// Shared ticket chrome — status / priority pills and relative
// timestamps. Kept in one place so the queue, the detail header and the
// dashboard never drift on colour or wording.

const STATUS_STYLES = {
  OPEN: "bg-sky-100 text-sky-700 dark:bg-sky-900/30 dark:text-sky-300",
  IN_PROGRESS:
    "bg-indigo-100 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-300",
  PENDING:
    "bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300",
  ESCALATED:
    "bg-rose-100 text-rose-700 dark:bg-rose-900/30 dark:text-rose-300",
  RESOLVED:
    "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300",
  CLOSED:
    "bg-slate-200 text-slate-600 dark:bg-slate-700 dark:text-slate-300",
};

const PRIORITY_STYLES = {
  URGENT: "bg-rose-600 text-white",
  HIGH: "bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-300",
  NORMAL: "bg-slate-100 text-slate-600 dark:bg-slate-700 dark:text-slate-300",
  LOW: "bg-slate-100 text-slate-400 dark:bg-slate-800 dark:text-slate-500",
};

export function StatusBadge({ status }) {
  const key = String(status || "OPEN").toUpperCase();
  return (
    <span
      className={`px-2.5 py-1 text-[11px] font-bold rounded-full whitespace-nowrap ${
        STATUS_STYLES[key] || STATUS_STYLES.OPEN
      }`}
    >
      {key.replace(/_/g, " ")}
    </span>
  );
}

export function PriorityBadge({ priority }) {
  const key = String(priority || "NORMAL").toUpperCase();
  return (
    <span
      className={`px-2 py-0.5 text-[11px] font-bold rounded-md whitespace-nowrap ${
        PRIORITY_STYLES[key] || PRIORITY_STYLES.NORMAL
      }`}
    >
      {key}
    </span>
  );
}

export function QueueBadge({ queue }) {
  return (
    <span className="px-2 py-0.5 text-[11px] font-semibold rounded-md bg-violet-50 text-violet-700 dark:bg-violet-900/25 dark:text-violet-300 whitespace-nowrap">
      {String(queue || "GENERAL").replace(/_/g, " ")}
    </span>
  );
}

// "3h ago" / "2d ago" — the queue is scanned, not read, so absolute
// timestamps cost more than they inform.
export function timeAgo(value) {
  if (!value) return "—";
  const then = new Date(value).getTime();
  if (Number.isNaN(then)) return "—";
  const mins = Math.floor((Date.now() - then) / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days}d ago`;
  return new Date(value).toLocaleDateString();
}
